import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[solDynamicHost]',
  standalone: true
})
export class DynamicHostDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
